import React from 'react';
import CommonHeader from '@/components/CommonHeader';
import $i18n from '@/i18n';
// import { Button, Icon } from '@b-design/fusion';
import styles from './index.module.less';

// TODO
const breadcrumbConfig = [
  {
    key: 'approvals',
    breadcrumbName: $i18n.get({ id: 'aopf.pages.approvals.breadcrumbNameApprovals', dm: '审批' }),
    path: '/approvals',
  },
  // {
  //   key: 'details',
  //   breadcrumbName: $i18n.get({ id: 'aopf.pages.miniapp.ApplicationDetails', dm: '应用详情' }),
  // },
];

const Header: React.FC = () => {
  return (
    <div className={styles.inviteContainer}>
      <CommonHeader
        title={$i18n.get({ id: 'aopf.pages.approvals.title', dm: '任务管理' })}
        // backTo={`/overview${location.search}`}
        breadcrumbs={breadcrumbConfig}
      />
    </div>
  );
};
export default Header;
